import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './list_filter.css';

export default class ListFilter extends React.Component {
  constructor(props) {
    super(props);

    this._changeValue = this._changeValue.bind(this);

    this.state = {
      number: 1
    }
  }

  _changeValue(value) {
    this.setState({number: parseInt(value)});
    this.props.onChangeEvt(parseInt(value));
  }

  render() {
    return <div className={'list_filter'}>
        <strong>
          {this.props.type === 'angebot' && 'Verfügbare Schlafplätze: '}
          {this.props.type === 'gesuch' && 'Benötigte Schlafplätze: '}
        </strong>
        <div className={'list_filter_inner'}>
          <select onChange={(e) => this._changeValue(e.target.value)}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">Mehr als 10</option>
          </select>
        </div>
      </div>;
  }
  
}